"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { Component } from "react";
import Tooltip from "./Tooltip";
import { observable } from "mobx";
import { observer } from "mobx-react";
const ErrorTooltipTimeout = 3500;
const withErrorTimeout = (WrappedTooltip) => {
  let WithErrorTimeout = class extends Component {
    constructor() {
      super(...arguments);
      this.showTooltip = false;
      this.tooltipTimeout = null;
    }
    componentDidMount() {
      this.showTooltip = true;
      this.tooltipTimeout = setTimeout(() => {
        this.showTooltip = false;
      }, ErrorTooltipTimeout);
    }
    componentWillUnmount() {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
    }
    render() {
      const { props } = this;
      return /* @__PURE__ */ React.createElement(WrappedTooltip, { isError: true, show: this.showTooltip, ...props });
    }
  };
  __decorateClass([
    observable.ref
  ], WithErrorTimeout.prototype, "showTooltip", 2);
  WithErrorTimeout = __decorateClass([
    observer
  ], WithErrorTimeout);
  return WithErrorTimeout;
};
const TooltipWithErrorTimeout = withErrorTimeout(Tooltip);
const ErrorTooltip = (props) => {
  const { children, renderTooltip } = props;
  return renderTooltip ? /* @__PURE__ */ React.createElement(TooltipWithErrorTimeout, { ...props }) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export default ErrorTooltip;
export { TooltipWithErrorTimeout, withErrorTimeout, ErrorTooltipTimeout };
